<ng-template #loadingGroups>
  <app-loading-spinner></app-loading-spinner>
</ng-template>
<ng-template #groupTpl let-group>
  <fieldset class="group">
    <legend class="group__legend">{{ group.name }}</legend>
    <div class="group__licenses">
      <ng-container
        *ngFor="let license of group.licenses; trackBy: trackByLicense"
      >
        <div
          class="group__license"
          [ngbPopover]="licenseContent"
          triggers="mouseenter:mouseleave"
          container="body"
        >
          <app-switch-checkbox
            [checked]="license.enabled"
            [hoverable]="false"
            [disabled]="isDisabled(license)"
            [bsClass]="license | featureToggleColor"
            (change)="
              addFeatureToggleLicense.emit({
                licenseCode: license.code,
                addLicense: $event
              })
            "
          ></app-switch-checkbox>
          <ng-template #licenseContent>
            <div class="license-content">
              <div>
                <span class="license-content--title">When enabled: </span
                >{{ license.description }}
              </div>
              <div>
                <span class="license-content--title">Maturity: </span>
                <span
                  *ngIf="
                    license.maturity.toLowerCase() === 'deprecated';
                    else false
                  "
                >
                  This feature toggle is deprecated and will soon be removed.
                  Please remove all references as soon as possible.
                </span>
                <span
                  *ngIf="
                    license.maturity.toLowerCase() !== 'deprecated';
                    else false
                  "
                >
                  This feature can be enabled for
                  {{ license.maturity.toLowerCase() }}
                </span>
              </div>
              <div>
                <span class="license-content--title">Owner team: </span
                >{{ license.ownerTeam }}
              </div>
              <div>
                <span class="license-content--title">Managed by: </span
                >{{ license.managedBy }}
              </div>
              <div>
                <span class="license-content--title">Code: </span>
                <span class="license-content--code">{{ license.code }}</span>
              </div>
              <div *ngIf="license.disabled && license.disabledForPackage">
                <span class="license-content--title"
                  >Enabled by license package:
                </span>
                {{ license.disabledForPackage }}
              </div>
              <div *ngIf="license.readOnly">
                <span class="license-content--title">Read-only: </span>Yes
              </div>
              <div class="license-content--error" *ngIf="isFailed(license)">
                <i class="fa fa-exclamation-triangle"></i>
                Bootstrap failed for this feature. It is not available for this
                account. Contact support to resolve this.
              </div>
            </div>
          </ng-template>
          <div class="group__node">
            <span [ngClass]="'group__node--maturity ' + license.maturity">{{
              license.maturity
            }}</span>
            <span class="name">{{ license.displayName }} </span>
            <app-loading-spinner
              class="license-loading"
              size="sm"
              *ngIf="license.state === AccountState.Pending"
            ></app-loading-spinner>
          </div>
        </div>
      </ng-container>
    </div>
  </fieldset>
</ng-template>
<div class="columns" *ngIf="!loading; else loadingGroups">
  <div class="columns__col">
    <ng-container
      *ngFor="let group of leftGroups; trackBy: trackByGroup"
      [ngTemplateOutlet]="groupTpl"
      [ngTemplateOutletContext]="{ $implicit: group }"
    ></ng-container>
  </div>
  <div class="columns__col">
    <ng-container
      *ngFor="let group of rightGroups; trackBy: trackByGroup"
      [ngTemplateOutlet]="groupTpl"
      [ngTemplateOutletContext]="{ $implicit: group }"
    ></ng-container>
  </div>
</div>
